import {
  apiRequest,
  pensiunListparicipant,
  detailSubmission,
  pensiunInactive,
} from "../../../../../services/adapters/kepegawaian/filePersiapanPensiunService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      pensiunListparicipant,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchDetailSubmission = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      detailSubmission,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchInactive = async (query) => {
    return await apiRequest(
      "post",
      pensiunInactive,
      {
        body: query,
      },
      true
    );
  };
}

export default DataTableRepository;
